import { render, staticRenderFns } from "./AuthorizationsShowPage.vue?vue&type=template&id=8b70a434&scoped=true&"
import script from "./AuthorizationsShowPage.vue?vue&type=script&lang=js&"
export * from "./AuthorizationsShowPage.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationsShowPage.vue?vue&type=style&index=0&id=8b70a434&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b70a434",
  null
  
)

export default component.exports